import { autoPlacement, autoUpdate, shift, useDismiss, useFloating, useInteractions } from '@floating-ui/react';

import { memo, useEffect } from 'react';

import ReactPortal from 'components/global/ReactPortal';

import DynamicListMenu from './DynamicListMenu';
import * as S from './DynamicListMenu.styled';

/**
 * @author Burak Unsal
 */
const DynamicListContextMenu = (props) => {
	const {
		menuItems,
		row,
		anchorPoint,
		onClose,
		copyValue,
		copyColumnValues,
		isContextMenuOpen,
		setIsContextMenuOpen
	} = props;

	const handleOpenChange = (value) => {
		setIsContextMenuOpen(value);
		if (!value) {
			onClose();
		}
	};

	const { refs, floatingStyles, context } = useFloating({
		open: isContextMenuOpen,
		onOpenChange: handleOpenChange,
		placement: 'bottom-start',
		middleware: [
			autoPlacement({
				alignment: 'start',
				allowedPlacements: ['bottom-start', 'bottom-end', 'top-start', 'top-end']
			}),
			shift()
		],
		whileElementsMounted: autoUpdate
	});

	const dismiss = useDismiss(context);

	const { getFloatingProps } = useInteractions([dismiss]);

	useEffect(() => {
		refs.setPositionReference({
			getBoundingClientRect() {
				return {
					left: anchorPoint.x,
					top: anchorPoint.y,
					width: 0,
					height: 0
				};
			}
		});
	}, [refs, anchorPoint]);

	if ((!copyValue && !copyColumnValues && (menuItems?.length ?? 0) <= 0) || refs.reference.current === null)
		return null;

	return (
		<ReactPortal wrapperId="DynamicListContextMenu">
			<S.ContentWrapper ref={refs.setFloating} style={floatingStyles} {...getFloatingProps()}>
				<DynamicListMenu
					menuItems={menuItems}
					row={row}
					anchorPoint={anchorPoint}
					onClose={onClose}
					copyValue={copyValue}
					copyColumnValues={copyColumnValues}
				/>
			</S.ContentWrapper>
		</ReactPortal>
	);
};

export default memo(DynamicListContextMenu);
